import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { STAGE_LABELS, fmtDateShort } from "@/lib/constants";
import { Progress } from "@/components/ui/progress";
import { Wrench } from "lucide-react";

export default function Workshop() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const isApproverView = user?.role === "approver";

  useEffect(() => {
    api
      .get("/reports", { params: { status: "dalam_perbaikan" } })
      .then(({ data }) =>
        setReports(isApproverView ? data.filter((r) => !r.workshop_id) : data)
      )
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl">
          Tindak Lanjut Bengkel
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          {isApproverView
            ? 'Laporan "Bengkel Lain" (eksternal) di divisi Anda. Klik untuk memperbarui progres & mengunggah dokumentasi.'
            : 'Laporan berstatus "Dalam Perbaikan". Klik untuk memperbarui progres & dokumentasi.'}
        </p>
      </div>

      {loading ? (
        <p className="text-sm text-slate-400">Memuat…</p>
      ) : reports.length === 0 ? (
        <div className="rounded-md border border-slate-200 bg-white p-14 text-center shadow-sm">
          <Wrench className="mx-auto h-8 w-8 text-slate-300" />
          <p className="mt-2 text-sm text-slate-400">Tidak ada perbaikan berjalan.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {reports.map((r) => (
            <button
              key={r.id}
              data-testid={`workshop-card-${r.id}`}
              onClick={() => navigate(`/reports/${r.id}`)}
              className="rounded-md border border-slate-200 bg-white p-5 text-left shadow-sm transition-colors hover:bg-slate-50"
            >
              <div className="flex items-center justify-between">
                <span className="font-medium text-[var(--sipkd-primary)]">{r.report_number}</span>
                <span className="text-xs text-slate-400">{fmtDateShort(r.created_at)}</span>
              </div>
              <p className="mt-2 font-num text-lg font-bold text-slate-900">{r.plate_number}</p>
              <div className="mt-1 flex items-center gap-2">
                <span className="text-xs text-slate-500">{r.workshop_name || "-"}</span>
                {!r.workshop_id && r.workshop_name && (
                  <span className="rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
                    Bengkel Lain
                  </span>
                )}
              </div>
              <p className="mt-1 line-clamp-2 text-sm text-slate-600">{r.damage_description}</p>
              <div className="mt-3">
                <div className="mb-1 flex items-center justify-between text-xs text-slate-500">
                  <span>{STAGE_LABELS[r.progress_stage] || "Diperiksa"}</span>
                  <span className="font-num font-semibold">{r.progress_percent || 0}%</span>
                </div>
                <Progress value={r.progress_percent || 0} className="h-1.5" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
